import React, { useEffect, useState } from 'react'
import style from './SelectMyProject.module.scss'
import { useAppSelector } from '../../starter/hooks/redux'
import { useDrop } from 'react-dnd'
import {
  useCreateUserProjectMutation,
  useDeleteUserProjectMutation,
  useGetProjectsQuery
} from '../../starter/api/projectsApi'
import { IProject } from '../../starter/model/interfaces'
import CardProjectSmall from '../CardProjectSmall/CardProjectSmall'

const SelectMyProject = () => {
  const { data: allProjects } = useGetProjectsQuery()
  const { projects: myProjects } = useAppSelector((state) => state.projects)
  const [createUserProject] = useCreateUserProjectMutation()
  const [deleteUserProject] = useDeleteUserProjectMutation()

  const [filteredAllProject, setFilteredAllProject] = useState<IProject[]>(allProjects || [])

  useEffect(() => {
    if (allProjects && allProjects.length) {
      setFilteredAllProject(allProjects.filter((project) => !myProjects.map((proj) => proj._id).includes(project._id)))
    }
  }, [allProjects, myProjects])

  const [{ isActive: isActiveEmployeeAddDrop }, dropAddRef] = useDrop({
    accept: 'project-small',
    drop(item: IProject) {
      if (!myProjects.map((e) => e._id).includes(item._id)) {
        createUserProject(item._id)
      }
    },
    collect: (monitor) => ({
      isActive: monitor.canDrop() && monitor.isOver()
    })
  })

  const [{ isActive: isActiveEmployeeRemoveDrop }, dropRemoveRef] = useDrop({
    accept: 'project-small',
    drop(item: IProject) {
      if (myProjects.map((e) => e._id).includes(item._id)) {
        deleteUserProject(item._id)
      }
    },
    collect: (monitor) => ({
      isActive: monitor.canDrop() && monitor.isOver()
    })
  })
  return (
    <div className={style.wrapper}>
      <div className={style.titles}>
        <div className={style.title}>Мои проекты</div>
        <div className={style.title}>Все проекты</div>
      </div>
      <div className={style.areas}>
        <div className={[style.areaWrapper, isActiveEmployeeAddDrop ? style.isActive : ''].join(' ')} ref={dropAddRef}>
          <div className={[style.areaItem].join(' ')}>
            {myProjects.map((project) => (
              <CardProjectSmall key={project._id} project={project} />
            ))}
          </div>
        </div>

        <div
          className={[style.areaWrapper, isActiveEmployeeRemoveDrop ? style.isActive : ''].join(' ')}
          ref={dropRemoveRef}>
          <div className={[style.areaItem].join(' ')}>
            {filteredAllProject.map((project) => (
              <CardProjectSmall key={project._id} project={project} />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
export default SelectMyProject
